import { Row, Col, Card } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import classes from "./Dashboard.module.css";
import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataContext from "../../../Context/dataContext";
// import UsersTable from "./SalesTable";

const DataCards = (props) => {
  const employeeData = useContext(DataContext);
  const navigate = useNavigate();
  console.log(props,"props in datacards is this");
  console.log(employeeData.permission, "irrroeioeieoieoieoieo");

  // Function to handle the click on Total Number of Users
  const showUserList = () => {
    // Navigate to AllUsers page with usersList data
    navigate(`/admin/all-users`, { state: { usersList: props.data?.UsersList?.rows || [] } });
  };
  const showSiteList = () => {
    // Navigate to AllUsers page with usersList data
    navigate(`/admin/all-sites`, { state: { sitesList: props.data?.SitesList?.rows || [] } });
  };

  return (
    <Row>
      <Col
        lg={{ span: 12, offset: 0 }}
        md={11}
        xs={24}
        className={classes["Col"]}
      >
        <Card
          style={{
            backgroundColor: "#daebf336",
            display: "flex",
            alignItems: "center",
            cursor: "pointer", // Add pointer cursor to indicate it's clickable
          }}
          bordered={true}
          className={classes["Card"]}
          onClick={showUserList} // Add click handler
        >
          <Row
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            {/* Text Column */}
            <Col
              lg={12}
              md={12}
              xs={24}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  color: "#45b6fe",
                  fontSize: "24px",
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                }}
              >
                Total Number of Users
              </span>
            </Col>

            {/* Number Column */}
            <Col
              lg={12}
              md={12}
              xs={24}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <div
                className={classes["Rata1"]}
                style={{ textAlign: "right", marginLeft:"17rem" }}
              >
                {props.data.TotalUsersValue ?? null}
              </div>
            </Col>
          </Row>
        </Card>
      </Col>
       <Col
        lg={{ span: 12, offset: 0 }}
        md={11}
        xs={24}
        className={classes["Col"]}
      >
        <Card
          style={{
            backgroundColor: "#daebf336",
            display: "flex",
            alignItems: "center",
            cursor: "pointer", // Add pointer cursor to indicate it's clickable
          }}
          bordered={true}
          className={classes["Card"]}
          onClick={showSiteList} // Add click handler
        >
          <Row
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            {/* Text Column */}
            <Col
              lg={12}
              md={12}
              xs={24}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  color: "#45b6fe",
                  fontSize: "24px",
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                }}
              >
                Total Sites
              </span>
            </Col>

            {/* Number Column */}
            <Col
              lg={12}
              md={12}
              xs={24}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <div
                className={classes["Rata1"]}
                style={{ textAlign: "right", marginLeft: "25rem" }}
              >
                {props.data.TotalSitesValue ?? null}
              </div>
            </Col>
          </Row>
        </Card>
      </Col>

     
    </Row>
  );
};

export default DataCards;